angular.module('iw.frontyard.signup')
    .service('SignupAPIHelper', function (SignupLendingAPIHelper) {
        return new SignupLendingAPIHelper();
    });